import React from "react";
import { Table } from "@wac-ui-dashboard/wac_component_library";
import useSubCards from "./useSubCards";
import Style from "./subCards.module.scss";
import StatusCard from "../../../Global/StatusCard";
const SubCards = () => {
  const { subCardsDetails, getRow } = useSubCards();
  return (
    <div className="pro-p-5">
      <div className={`pro-d-flex ${Style.wrapper}`}>
        <div className={`${Style.wrapper_child}`}>
          <p className="pro-mb-0">GLI No.</p>
        </div>
        <span className="pro-d-iniline-block pro-px-2 pro-pe-5 pro-lh-1">
          {" "}
          :{" "}
        </span>
        <div className={`${Style.wrapper_child}`}>
          <p className="pro-ttl pro-mb-0">{subCardsDetails?.gli_number}</p>
        </div>
      </div>

      <div className={`pro-d-flex ${Style.wrapper}`}>
        <div className={`${Style.wrapper_child}`}>
          <p className=" pro-mb-0">Shop</p>
        </div>
        <span className="pro-d-iniline-block pro-px-2 pro-pe-5 pro-lh-1">
          {" "}
          :{" "}
        </span>
        <div className={`${Style.wrapper_child}`}>
          <p className="pro-ttl pro-mb-0">{subCardsDetails?.shop}</p>
          <p className="pro-mb-0">{subCardsDetails?.shop_location}</p>
        </div>
      </div>

      <div className={`pro-d-flex ${Style.wrapper}`}>
        <div className={`${Style.wrapper_child}`}>
          <p className="pro-mb-0">Supplier</p>
        </div>
        <span className="pro-d-iniline-block pro-px-2 pro-pe-5 pro-lh-1">
          {" "}
          :{" "}
        </span>
        <div className={`${Style.wrapper_child}`}>
          <p className="pro-mb-0 pro-ttl">{subCardsDetails?.supplier}</p>
          <p className="pro-mb-0">{subCardsDetails?.supplier_location}</p>
        </div>
      </div>

      <div className={`pro-d-flex ${Style.wrapper}`}>
        <div className={`${Style.wrapper_child}`}>
          <p className=" pro-mb-0">Item Type</p>
        </div>
        <span className="pro-d-iniline-block pro-px-2 pro-pe-5 pro-lh-1">
          {" "}
          :{" "}
        </span>
        <div className={`${Style.wrapper_child}`}>
          <p className="pro-mb-0 pro-ttl">{subCardsDetails?.item_type}</p>
        </div>
      </div>
      <div className={`pro-d-flex ${Style.wrapper}`}>
        <div className={`${Style.wrapper_child}`}>
          <p className=" pro-mb-0">Remark</p>
        </div>
        <span className="pro-d-iniline-block pro-px-2 pro-pe-5 pro-lh-1">
          {" "}
          :{" "}
        </span>
        <div className={`${Style.wrapper_child}`}>
          <p className="pro-mb-0 pro-ttl">{subCardsDetails?.remark}</p>
        </div>
      </div>
      {subCardsDetails?.created_at && (
        <div className={`pro-d-flex ${Style.wrapper}`}>
          <div className={`${Style.wrapper_child}`}>
            <p className=" pro-mb-0">Created at</p>
          </div>
          <span className="pro-d-iniline-block pro-px-2 pro-pe-5 pro-lh-1">
            {" "}
            :{" "}
          </span>
          <div className={`${Style.wrapper_child}`}>
            <p className="pro-mb-0 pro-ttl">{subCardsDetails?.created_at}</p>
          </div>
        </div>
      )}
      {subCardsDetails?.service && (
        <div className={`${Style.wrapper} pro-pt-4`}>
          <h6 className="pro-ttl h6 pro-mb-0">Services</h6>
          <ul className="pro-mt-2">
            {subCardsDetails?.service?.map((value, index) => (
              <li key={index} className="pro-badge badge-grey">
                {value}
              </li>
            ))}
          </ul>
        </div>
      )}
      {(subCardsDetails?.rejected || subCardsDetails?.canceled) && (
        <div className="pro-d-flex pro-gap-3 pro-mt-3 pro-d-flex-wrap">
          <StatusCard
            title="Rejected"
            count={subCardsDetails?.rejected ?? "NaN"}
            color="#F44336"
          />
          <StatusCard
            title="Cancelled"
            count={subCardsDetails?.canceled ?? "NaN"}
            color="#9E9E9E"
          />
        </div>
      )}
      {subCardsDetails?.barcode?.data?.length > 0 && (
        <div className="pro-mt-4">
          <h6 className="pro-ttl h6 pro-mb-2">Barcode Work</h6>
          <Table
            multiSelect={false}
            data={subCardsDetails?.barcode?.data || []}
            uniqueID={"employee_name"}
            fields={subCardsDetails?.barcode?.fields}
            getRow={getRow}
            showCheckBox={false}
            assignable={false}
            deletable={false}
          />
        </div>
      )}
      {subCardsDetails?.raw_photo?.data?.length > 0 && (
        <div className="pro-mt-4">
          <h6 className="pro-ttl h6 pro-mb-2">Raw Photo Work</h6>
          <Table
            multiSelect={false}
            data={subCardsDetails?.raw_photo?.data || []}
            uniqueID={"employee_name"}
            fields={subCardsDetails?.raw_photo?.fields}
            getRow={getRow}
            showCheckBox={false}
            assignable={false}
            deletable={false}
          />
        </div>
      )}
    </div>
  );
};

export default SubCards;
